"use client"

import { useSession } from "next-auth/react"
import Link from "next/link"

interface Props {
  /** External URL (Adzuna) or internal path (/jobs/[id]) */
  href: string
  /** External jobs open in a new tab; internal jobs navigate within the app */
  external?: boolean
  currentPath: string
  className?: string
  label?: string
}

export default function ApplyButton({ href, external = false, currentPath, className, label = "Apply" }: Props) {
  const { status } = useSession()
  const isLoggedIn = status === "authenticated"

  const baseClass =
    className ??
    "shrink-0 text-sm px-3 py-1.5 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"

  if (isLoggedIn) {
    if (external) {
      return (
        <a href={href} target="_blank" rel="noopener noreferrer" className={baseClass}>
          {label}
        </a>
      )
    }
    return (
      <Link href={href} className={baseClass}>
        {label}
      </Link>
    )
  }

  // Not logged in — send to login with a callbackUrl back to this page
  return (
    <Link
      href={`/login?callbackUrl=${encodeURIComponent(currentPath)}`}
      className={baseClass}
    >
      {label}
    </Link>
  )
}
